import { Loader2, Trash2 } from 'lucide-react';

/** Confirms deleting one or more support tickets — permanent, for the admin and the member alike. */
const ConfirmDeleteTicketsModal = ({ count, busy, onCancel, onConfirm }) => (
  <div className="fixed inset-0 z-[90] flex items-center justify-center p-4" role="dialog" aria-modal="true" data-testid="tickets-delete-confirm">
    <button type="button" aria-label="Close" tabIndex={-1} className="absolute inset-0 bg-black/75 backdrop-blur-md" onClick={() => !busy && onCancel()} />
    <div className="relative sc-glass-strong rounded-2xl w-full max-w-md p-6" style={{ borderColor: 'rgba(255,107,107,0.35)' }}>
      <div className="flex items-center gap-2 text-[#FF6B6B] font-display font-bold text-lg">
        <Trash2 className="w-5 h-5" />
        Delete {count === 1 ? 'This Ticket' : `${count} Tickets`}?
      </div>
      <p className="text-[13px] text-[var(--sc-text-dim)] mt-3 leading-relaxed">
        {count === 1 ? 'The ticket and its whole conversation are' : 'These tickets and their conversations are'} removed for good — the member will no longer
        see {count === 1 ? 'it' : 'them'} on their Support page. This cannot be undone.
      </p>
      <div className="flex items-center justify-end gap-2 mt-6">
        <button type="button" onClick={onCancel} disabled={busy} className="sc-btn-ghost" style={{ padding: '10px 14px', fontSize: 12 }}>
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={busy}
          className="inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-[12px] font-bold uppercase tracking-[0.16em] text-white disabled:opacity-60"
          style={{ background: '#C0392B', border: '1px solid rgba(255,107,107,0.6)' }}
          data-testid="tickets-delete-confirm-btn"
        >
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Trash2 className="w-3.5 h-3.5" />}
          Delete {count === 1 ? 'Ticket' : 'Tickets'}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmDeleteTicketsModal;
